export enum TREATMENT_RECOMMENDATION_TIER {
  TIER_1 = 'tier1',
  TIER_2 = 'tier2',
  TIER_3 = 'tier3',
}
